<script lang="ts">
    import {Link} from "svelte-routing";
    import Button, {Label} from "@smui/button";

    export let to: string;
    export let text: string;
</script>

<Link to="{to}">
    <Button variant="unelevated">
        <Label>{text}</Label>
    </Button>
</Link>